module.exports = __webpack_public_path__ + "img/1504546930.31977b44.jpg";